import LMSDispatcher from "../LMSDispatcher";
import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import i18next from "i18next";

class DashboardActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getSampleStatus(payload: any, requestId: any) {
        try {
            const request = new ApiRequest(`/Dashboard/GetSampleStatus`,requestId, payload, i18next.t("Internal server error!"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DASHBOARD_SAMPLE_STATUS,
                payload: {
                    sampleData: result,
                }
            });
        } catch (error) {
            throw error;
        }
    }
    async getInstrumentAvailability(payload: any, requestId: any) {
        try {
            const request = new ApiRequest(`/Dashboard/getInstrumentAvailability`,requestId, payload, i18next.t("Internal server error!"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DASHBOARD_INSTRUMENT_AVAILABILITY,
                payload: {
                    instrumentData: result,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getTopPropertiesAlarmDetails(payload: any, requestId: any) {
        try {
            const request = new ApiRequest(`/Dashboard/getTopPropertiesAlarmDetails`,requestId, payload, i18next.t("Internal server error!"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DASHBOARD_TOP5_ALARMS,
                payload: {
                    top5Alarms: result,
                }
            });
        } catch (error) {
            throw error;
        }
    }
    async getGetActivityLog(payload: any, requestId: any) {
        try {
            const request = new ApiRequest(`/Dashboard/GetActivityLog`,requestId, payload, i18next.t("Internal server error!"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DASHBOARD_ACTIVITYLOG,
                payload: {
                    activityLog: result,
                }
            });
        } catch (error) {
            throw error;
        }
    }
    
}

const dashboardActions = new DashboardActions();
export default dashboardActions;